import classNames from 'classnames';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';

@observer
class DropdownSelect extends Component {
  handleToggle = (event, isOpen) => {
    const { focusSelectedItemOnKeyboardOpen, onToggle } = this.props;

    const isKeyboardOpenTrigger =
      event?.type === 'keydown' &&
      ['Enter', ' ', 'Spacebar', 'ArrowDown', 'ArrowUp'].includes(event.key);
    if (focusSelectedItemOnKeyboardOpen && isOpen && isKeyboardOpenTrigger) {
      setTimeout(() => {
        // Nested dropdowns change Reactstrap's default focus target, so explicitly
        // re-focus the currently selected option when opening via keyboard.
        const dropdownRoot =
          event?.currentTarget?.closest?.('.DropdownSelect') ||
          event?.target?.closest?.('.DropdownSelect');
        const menu = dropdownRoot?.querySelector('.dropdown-menu');
        const selectedItem =
          menu?.querySelector('.dropdown-item[aria-current="true"]') ||
          menu?.querySelector('.dropdown-item.active');
        const fallbackItem = menu
          ? Array.from(
              menu.querySelectorAll('.dropdown-item:not(.disabled)')
            )[0]
          : undefined;
        const itemToFocus = selectedItem || fallbackItem;
        if (itemToFocus && typeof itemToFocus.focus === 'function') {
          itemToFocus.focus();
        }
      }, 0);
    }

    if (typeof onToggle === 'function') {
      onToggle(event, isOpen);
    }
  };

  render() {
    const {
      label,
      children,
      disabled,
      isLarge,
      className,
      focusSelectedItemOnKeyboardOpen, // omit from props passed down
      onToggle, // omit since we wire our own handler
      ...props
    } = this.props;

    const styles = isLarge
      ? {
          overflowY: 'scroll',
          maxHeight: '500px',
        }
      : {};

    return (
      <UncontrolledDropdown
        className={classNames('DropdownSelect', className)}
        disabled={disabled}
        onToggle={this.handleToggle}
        {...props}
      >
        <DropdownToggle caret disabled={disabled}>
          {label}
        </DropdownToggle>
        <DropdownMenu style={styles}>{children}</DropdownMenu>
      </UncontrolledDropdown>
    );
  }
}

DropdownSelect.propTypes = {
  label: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  isLarge: PropTypes.bool,
  className: PropTypes.string,
  focusSelectedItemOnKeyboardOpen: PropTypes.bool,
  onToggle: PropTypes.func,
};

DropdownSelect.defaultProps = {
  isLarge: false,
  focusSelectedItemOnKeyboardOpen: false,
};

export default DropdownSelect;
